import { Schedule } from '@mui/icons-material';
import React from 'react';

import { OverdueAndDueDatesResponse } from '../../../../../../../lib/api/fundsDashboard/fundsDashboard';
import SemiPieChart from '../../../../../../../lib/designSystem/Charts/SemiPieChart';

interface DueSoonChartProps {
  data: OverdueAndDueDatesResponse;
}

const DueSoonChart: React.FC<DueSoonChartProps> = ({ data }) => {
  const chartData = React.useMemo(() => {
    if (!data?.dueSoonByDays) return [];

    return data.dueSoonByDays.map((item) => ({
      id: item.range,
      label: item.range,
      value: item.count,
    }));
  }, [data?.dueSoonByDays]);

  return (
    <SemiPieChart
      data={chartData}
      title="Vencimientos Próximos por Días"
      icon={<Schedule sx={{ fontSize: 18, color: '#ed6c02' }} />}
      color="#ed6c02"
    />
  );
};

export default DueSoonChart;
